module.exports = __webpack_public_path__ + "img/17_Angle.9762c384.png";